import { render, staticRenderFns } from "./Xiaoxiguanli.vue?vue&type=template&id=07bbf8f6&scoped=true&"
import script from "./Xiaoxiguanli.vue?vue&type=script&lang=js&"
export * from "./Xiaoxiguanli.vue?vue&type=script&lang=js&"
import style0 from "./Xiaoxiguanli.vue?vue&type=style&index=0&id=07bbf8f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbf8f6",
  null
  
)

export default component.exports